import { useEffect } from "react";
import { DecimalHelper } from "@/helpers";
import { useAppDispatch, useAppSelector } from "@/stores";
import {
  tenantDailyReportWithdrawSelects,
  tenantDailyReportWithdrawThunks,
} from "./store";
import { ReportItem } from "./types";
// components
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";

export const TenantDailyReportWithdrawListPage = () => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector(tenantDailyReportWithdrawSelects.loading);

  const items = useAppSelector(tenantDailyReportWithdrawSelects.items);

  useEffect(() => {
    void dispatch(tenantDailyReportWithdrawThunks.list());
  }, [dispatch]);

  const columns: ColumnsType<ReportItem> = [
    {
      width: 100,
      title: "日期",
      dataIndex: "date",
    },
    {
      width: 100,
      title: "筆數",
      align: "right",
      key: "count",
      render(_, { count }) {
        return <div className="t:right">{DecimalHelper.locale(count)}</div>;
      },
    },
    {
      width: 150,
      title: "申請總顆數",
      align: "right",
      key: "amount",
      render(_, { amount }) {
        return <div className="t:right">{DecimalHelper.locale(amount)}</div>;
      },
    },
    {
      width: 150,
      title: "累計通道費",
      align: "right",
      key: "expend",
      render(_, { expend }) {
        return <div className="t:right">{DecimalHelper.locale(expend)}</div>;
      },
    },
    {
      title: "",
      render() {
        return <div className="t:right"></div>;
      },
    },
  ];

  return (
    <div className="flex flex:col gap:8">
      <Table
        rowKey="id"
        tableLayout="fixed"
        loading={loading}
        columns={columns}
        dataSource={items}
        scroll={{ x: "1600px" }}
      ></Table>
    </div>
  );
};
